import { appblob } from './ApiBlob';

const schedules = async ({ start, end }) => {
    return appblob.get(`report/schedule?start=${start || ''}&end=${end || ''}`, {
        responseType: 'blob'
    });
};

export { schedules };
